/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./digitalTwinRulesMonitor.vue?vue&type=template&id=b81c1286&scoped=true&"
import script from "./digitalTwinRulesMonitor.vue?vue&type=script&lang=js&"
export * from "./digitalTwinRulesMonitor.vue?vue&type=script&lang=js&"
import style0 from "./digitalTwinRulesMonitor.vue?vue&type=style&index=0&id=b81c1286&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81c1286",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VAlert,VBtn,VCol,VContainer,VDataTable,VIcon,VRow,VSwitch})
